// Help & support (prototype/admin/src/85-account.js helpPage()): questions, and the way back to
// a hidden setup checklist. Chat, status and the changelog come with support tooling later.
import { useState } from 'react';
import { L } from '../lib/prefs';
import { go } from '../lib/route';
import { setSetupHidden, useApp } from '../lib/session';
import { Btn, Card, Empty, Ic, PageHead } from '../ui/kit';
import { toast } from '../ui/toast';
import { FAQ } from './faq';

export function Help() {
  const { setup } = useApp();
  const [q, setQ] = useState('');
  const ql = q.toLowerCase();
  const list = FAQ.filter(f => !ql || (f[0] + f[2] + f[1] + f[3]).toLowerCase().includes(ql));
  const show = async () => {
    try { await setSetupHidden(false); go('dashboard'); }
    catch { toast(L('Couldn\'t show the checklist. Check your connection and try again.', 'تعذر الإظهار. تحقق من الاتصال وحاول مجدداً.'), { tone: 'bad' }); }
  };
  const open = !!setup && setup.hidden && setup.done < setup.total;
  return (
    <>
      <PageHead title={L('Help & support', 'المساعدة والدعم')} sub={L('Answers, a person to talk to, and what\'s new.', 'إجابات، وشخص للتحدث، والجديد.')} />
      <label className="search big"><Ic n="search" /><input id="hq" value={q} onChange={e => setQ(e.target.value)} placeholder={L('Search help, e.g. "bounced cheque"', 'ابحث، مثلاً «شيك مرتجع»')} autoComplete="off" /></label>
      <div className="grid g-12">
        <div className="span-8">
          <Card title={L('Common questions', 'أسئلة شائعة')}>
            {list.length ? (
              <div className="faq">{list.map((f, i) => <details key={f[0]} open={i === 0 && !q}><summary>{L(f[0], f[1])}<Ic n="chevD" cls="sm" /></summary><p>{L(f[2], f[3])}</p></details>)}</div>
            ) : <Empty icon="search" title={L('No answer found', 'لا إجابة')} />}
          </Card>
        </div>
        <div className="span-4 stack">
          {open ? <Card title={L('Setup checklist', 'قائمة الإعداد')}><Btn kind="ghost" sm onClick={() => void show()}>{L('Show it on the dashboard', 'أظهرها في اللوحة')}</Btn></Card> : null}
        </div>
      </div>
    </>
  );
}
